import { render, staticRenderFns } from "./ModalAddNewGroup.vue?vue&type=template&id=3a1e4948&scoped=true"
import script from "./ModalAddNewGroup.vue?vue&type=script&lang=js"
export * from "./ModalAddNewGroup.vue?vue&type=script&lang=js"
import style0 from "./ModalAddNewGroup.vue?vue&type=style&index=0&id=3a1e4948&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1e4948",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a1e4948')) {
      api.createRecord('3a1e4948', component.options)
    } else {
      api.reload('3a1e4948', component.options)
    }
    module.hot.accept("./ModalAddNewGroup.vue?vue&type=template&id=3a1e4948&scoped=true", function () {
      api.rerender('3a1e4948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalAddNewGroup.vue"
export default component.exports